import { AnyAction } from "redux"
import { ThunkAction } from "redux-thunk"
import { digitealActions, digitealSelectors, IDigitealTechnicalUser, requestThunk } from "swiipe.portal.shared"
import { endpoints } from "../../data/endpoints"
import { StoreState } from "../StoreState"

export const fetchDigitealTechnicalUserThunk =
    (merchantId: string, force: boolean): ThunkAction<void, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        if (!force && digitealSelectors.technicalUser(getState(), merchantId)) {
            return
        }

        const resp = await dispatch(
            requestThunk<IDigitealTechnicalUser>(endpoints.Digiteal.getTechnicalUser, {
                params: { merchantId },
            })
        )

        dispatch(
            digitealActions.setTechnicalUser({
                merchantId,
                technicalUser: resp,
            })
        )
    }

export interface IDigitealOnboardingEvent {
    type: string
    timestamp: string
    content: {
        changeType: string
    }
}

export interface IDigitealOnboardingEventsResponse {
    onboardingEvents: IDigitealOnboardingEvent[]
}

export const getDigitealOnboardingEventsThunk =
    (merchantId: string): ThunkAction<Promise<IDigitealOnboardingEventsResponse>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        const resp = await dispatch(
            requestThunk<IDigitealOnboardingEventsResponse>(endpoints.Digiteal.getOnboardingEvents, {
                params: { merchantId },
            })
        )
        return resp
    }

export interface IDigitealAddTechnicalUserData {
    swMerchantId: string
    username: string
    password: string
}

export const addDigitealTechnicalUserThunk =
    (data: IDigitealAddTechnicalUserData): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        await dispatch(
            requestThunk(endpoints.Digiteal.addTechnicalUser, {
                data: data,
            })
        )
        await dispatch(fetchDigitealTechnicalUserThunk(data.swMerchantId, true))
    }

export const removeDigitealTechnicalUserThunk =
    (swMerchantId: string): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        await dispatch(
            requestThunk(endpoints.Digiteal.removeTechnicalUser, {
                params: { swMerchantId },
            })
        )
        await dispatch(fetchDigitealTechnicalUserThunk(swMerchantId, true))
    }

export interface IDigitealCsvRow {
    PaymentId: string
    IssuerCountry: string
    Product: "CONSUMER" | "CORPORATE"
    Type?: "DEBIT" | "CREDIT"
}

export const addDigitealInvoicingDetailsThunk =
    (rows: IDigitealCsvRow[]): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        await dispatch(
            requestThunk(endpoints.Digiteal.addInvoicingDetails, {
                data: {
                    rows: rows.map((r) => ({
                        paymentId: r.PaymentId,
                        cardIssuerCountryCode: r.IssuerCountry,
                        cardProduct: r.Product === "CONSUMER" ? "Consumer" : r.Product === "CORPORATE" ? "Corporate" : undefined,
                        cardType: r.Type === "CREDIT" ? "Credit" : r.Type === "DEBIT" ? "Debit" : undefined,
                    })),
                },
            })
        )
    }
